import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { updateMetaTags, updateCanonicalURL, trackPageView, generateSEOContent } from '../utils/seo';

export const useSEO = (title, description, keywords, language = 'ar') => {
  const location = useLocation();

  useEffect(() => {
    // Update meta tags
    updateMetaTags(title, description, keywords);

    // Update canonical URL
    const baseUrl = 'https://socialboost.giize.com';
    const canonicalUrl = `${baseUrl}${location.pathname}`;
    updateCanonicalURL(canonicalUrl);

    // Track page view
    trackPageView(location.pathname, title);

    // Scroll to top
    window.scrollTo(0, 0);
  }, [title, description, keywords, location, language]);
};

export const useSEOByLanguage = (language = 'ar') => {
  const seoContent = generateSEOContent(language);
  useSEO(seoContent.title, seoContent.description, seoContent.keywords, language);
  return seoContent;
};

export const usePageSEO = (pageName, language = 'ar') => {
  // Build SEO content from the already-loaded translation content so that
  // EVERY supported language works, instead of only ar/en (which used to
  // crash the page for fr/es/de/tr/hi/fa/ur/zh because the lookup returned
  // undefined and its properties were accessed directly).
  const seoContentByLanguage = generateSEOContent(language);

  const pageContent =
    pageName === 'dashboard'
      ? {
          title: `${seoContentByLanguage.dashboardTitle} - SocialBoost`,
          description: seoContentByLanguage.dashboardDescription,
          keywords: seoContentByLanguage.keywords,
        }
      : {
          title: seoContentByLanguage.title,
          description: seoContentByLanguage.description,
          keywords: seoContentByLanguage.keywords,
        };

  useSEO(pageContent.title, pageContent.description, pageContent.keywords, language);
  return pageContent;
};
